module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ros.6a6c468b.jpg";